"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenGraphHead = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_helmet_1 = require("react-helmet");
/**
 * https://ogp.me/
 * https://developers.facebook.com/docs/sharing/webmasters/
 */
function OpenGraphHead({ description, title, type = "website", url, image, }) {
    const size = image.size;
    return ((0, jsx_runtime_1.jsxs)(react_helmet_1.Helmet, { children: [(0, jsx_runtime_1.jsx)("meta", { property: "og:title", content: title }), (0, jsx_runtime_1.jsx)("meta", { property: "og:type", content: type }), (0, jsx_runtime_1.jsx)("meta", { property: "og:url", content: url }), (0, jsx_runtime_1.jsx)("meta", { property: "og:image", content: image.url }), size && (0, jsx_runtime_1.jsx)("meta", { property: "og:image:width", content: size.width.toString() }), size && (0, jsx_runtime_1.jsx)("meta", { property: "og:image:height", content: size.height.toString() }), (0, jsx_runtime_1.jsx)("meta", { property: "og:site_name", content: "Snapchat" }), (0, jsx_runtime_1.jsx)("meta", { property: "og:description", content: description })] }));
}
exports.OpenGraphHead = OpenGraphHead;
//# sourceMappingURL=opengraph.js.map